
// const Dropdown = ({ label, options }) => {
//   return (
//     <div>
//       <label className="block mb-1 font-medium">{label}</label>
//       <select className="w-full px-3 py-2 border rounded-md">
//         {options.map((value) => (
//           <option key={value} value={value}>
//             {value} {label.toLowerCase()}
//           </option>
//         ))}
//       </select>
//     </div>
//   );
// };

import { useEffect, useState } from "react";

// const SubscriptionSelector = () => {
//   const days = Array.from({ length: 30 }, (_, i) => i + 1); 
//   const months = Array.from({ length: 12 }, (_, i) => i + 1); 
//   const years = Array.from({ length: 10 }, (_, i) => i + 1);

//   return (
//     <div className="gap-2 p-6 mt-2 border border-orange-400 rounded-lg">
//       <label className="block mb-4 font-medium">Choose Subscription Periods</label>
//       <div className="flex gap-4">
//         <Dropdown label="Days" options={days} />
//         <Dropdown label="Month" options={months} />
//         <Dropdown label="Year" options={years} />
//       </div>
//     </div>
//   );
// };

// export default SubscriptionSelector;





// Dropdown component to handle the individual dropdowns
const Dropdown = ({ label, options, value, onChange }) => {
  return (
    <div>
      <label className="block mb-1 font-medium">{label}</label>
      <select
        className="w-full px-3 py-2 border rounded-md"
        value={value}
        onChange={(e) => onChange(Number(e.target.value))} // Ensure that the value is always a number
      >
        <option value={0}>Choose {label}</option> {/* Add "Choose" option */}
        {options.map((value) => (
          <option key={value} value={value}>
            {value} {label.toLowerCase()}
          </option>
        ))}
      </select>
    </div>
  );
};

// Main SubscriptionSelector component
const SubscriptionSelector = ({onSubscriptionChange, initialValues}) => {
  // State to manage the selected values of day, month, and year
  const [selectedDay, setSelectedDay] = useState(initialValues?.day || 0); // Default to 0
  const [selectedMonth, setSelectedMonth] = useState(initialValues?.month || 0); // Default to 0
  const [selectedYear, setSelectedYear] = useState(initialValues?.year || 0); // Default to 0

  // Update state when initialValues change (for edit mode)
  useEffect(() => {
    if (initialValues) {
      setSelectedDay(initialValues.day || 0);
      setSelectedMonth(initialValues.month || 0);
      setSelectedYear(initialValues.year || 0);
    }
  }, [initialValues]);

console.log("selectedDay",selectedDay,selectedYear,selectedMonth)

useEffect(() => {
    if (onSubscriptionChange) {
      onSubscriptionChange({
        day: selectedDay,
        month: selectedMonth,
        year: selectedYear,
      });
    }
  }, [selectedDay, selectedMonth, selectedYear]);
  // Array for dropdown options
  const days = Array.from({ length: 30 }, (_, i) => i + 1); // Days from 1 to 30
  const months = Array.from({ length: 12 }, (_, i) => i + 1); // Months from 1 to 12
  const years = Array.from({ length: 10 }, (_, i) => i + 1); // Years from 2025 to 2034

  // Handle change for each dropdown
  const handleDayChange = (value) => setSelectedDay(value);
  const handleMonthChange = (value) => setSelectedMonth(value);
  const handleYearChange = (value) => setSelectedYear(value);

  return (
    <div className="gap-2 p-6 mt-2 border border-orange-400 rounded-lg">
      <label className="block mb-4 font-medium">Choose Subscription Periods</label>
      <div className="flex gap-4">
        <Dropdown
          label="Days"
          options={days}
          value={selectedDay}
          onChange={handleDayChange}
        />
        <Dropdown
          label="Month"
          options={months}
          value={selectedMonth}
          onChange={handleMonthChange}
        />
        <Dropdown
          label="Year"
          options={years}
          value={selectedYear}
          onChange={handleYearChange}
        />
      </div>

    </div>
  );
};

export default SubscriptionSelector;
